import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 200,
    },
    seeMoreButton: {
      marginTop: theme.spacing(2),
    },
    cardTitle: {
      color: theme.palette.text.secondary,
    },
    cardHeaderWithoutPaddingBottom: {
      paddingBottom: 0,
    },
    cardHeaderWithoutPaddingTop: {
      paddingTop: 0,
    },
    cardSubHeaderWithoutPaddingTop: {
      marginTop: 0,
    },
    cardContentWithouPaddingTop: {
      paddingTop: 0,
    },
    borderGreen: {
      borderLeft: `4px solid ${theme.palette.success.main}`,
    },
    cardIconRight: {
      position: 'absolute',
      top: 26,
      right: -2,
      fontSize: 40,
    },
    purpleBackground: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    redBackground: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    borderOrange: {
      borderLeft: `4px solid ${theme.palette.warning.main}`,
    },
    orangeText: {
      color: theme.palette.warning.main,
    },
    cardIconRightGrey: {
      position: 'absolute',
      top: 38,
      right: -2,
      fontSize: 40,
      color: theme.palette.text.disabled,
    },
    cardTitleSmall: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '16px',
      color: theme.palette.text.secondary,
    },
    textTruncated: {
      textOverflow: 'ellipsis',
      width: '11rem',
      overflow: 'hidden',
    },
    selectMenu: {
      '&&:focus': {
        backgroundColor: 'transparent',
      },
    },
  }),
);

export default useStyles;
